import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    // { key: 'contactId', label: 'รหัสสมาชิก (ผูัซื้อ)', sortable: true },
    { key: 'contactNo', label: 'รหัสสมาชิก (ผูัซื้อ)', sortable: true },
    { key: 'fullName', label: 'ชื่อ - นามสกุล', sortable: true },
    // { key: 'firstName', label: 'First Name', sortable: true },
    // {
    //   key: 'currentPlan',
    //   label: 'Last Name',
    //   formatter: title,
    //   sortable: true,
    // },
    { key: 'phone', label: 'เบอร์โทรศัพท์', sortable: true },
    { key: 'email', label: 'อีเมล', sortable: true },
    // { key: 'contactType', label: 'ประเภทผู้ใช้งาน', sortable: true },
    { key: 'shopTypeName', label: 'ประเภทผู้ใช้งาน', sortable: true },
    { key: 'active', label: "สถานะ", sortable: true },
    // { key: 'actions' },
  ]

  // const tableColumns = [
  //   { key: 'userAddressId', label: 'รหัสผู้ใช้งาน', sortable: true },
  //   { key: 'contactName', label: 'ชื่อ - นามสกุล', sortable: true },
    
  //   { key: 'phone', label: 'เบอร์โทรศัพท์', sortable: true },
  //   { key: 'email', label: 'อีเมล', sortable: true },
  //   { key: 'role', label: 'ประเภทผู้ใช้งาน', sortable: true },
  //   { key: 'status', label: "สถานะ", sortable: true },
  //   { key: 'actions' },
  // ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const userModel = ref({
    userName: "",
    password: "",
    title: "",
    firstName: "",
    lastName: "",
    phoneMobile: "",
    email1: "",
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchUsers = (ctx, callback) => {
    store
      .dispatch('members/fetchUsers', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data, totalCount } = response

        callback(data)
        totalUsers.value = totalCount
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === true) return 'success'
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
    userModel
  }
}
